export const NPS_SCORES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export const TEST_QUOTE_SURVEY_ID = 242336
export const PROD_QUOTE_SURVEY_ID = 244196
